<template>
  <div>
    <v-row class="list-header d-flex">
      <v-col style="flex-grow:0">
        <search-list
          v-if="searchable"
          @search="handleSearch"
        />
      </v-col>
      <v-col
        v-if="filterable"
        class="d-flex align-center justify-space-between"
      >
        <list-filter-menu
          :selected-filters="selectedFilters"
          :filters="filterOptions"
          @add-filter="handleFilter"
          @clear-filters="handleClearFilters"
        />
      </v-col>
      <slot />
    </v-row>
    <v-row class="list-header d-flex">
      <v-col>
        <template v-for="(slot, name) in filterSlots">
          <filter-menu
            v-if="selectedFilters.includes(unKebab(name))"
            :key="name"
            :label="unKebab(name)"
          >
            <slot :name="name" />
          </filter-menu>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import SearchList from '@/components/base/SearchList'
  import ListFilterMenu from '@/components/filters/ListFilterMenu'
  import FilterMenu from '@/components/filters/FilterMenu'

  export default {
    name: 'PropertySettingsHeader',
    components: { SearchList, ListFilterMenu, FilterMenu },
    props: {
      filterable: {
        type: Boolean,
        default: false,
      },
      searchable: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      selectedFilters: [],
    }),
    computed: {
      filterSlots () {
        const filterSlots = { ...this.$scopedSlots }
        if (filterSlots.default) delete filterSlots.default
        return filterSlots
      },
      filterOptions () {
        return Object.keys(this.filterSlots).map(slotName => this.unKebab(slotName))
      },
    },
    methods: {
      handleSearch (search) {
        this.$emit('search', search)
      },
      handleFilter (item) {
        this.selectedFilters.push(item)
      },
      handleClearFilters () {
        this.selectedFilters = []
        this.$emit('clear-filters')
      },
      unKebab (str) {
        return str.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ')
      },
    },
  }
</script>
